module.exports = __webpack_public_path__ + "img/serve4.5e66e609.png";